import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import ArticlePage from "./pages/ArticlePage";
import SearchPage from "./pages/SearchPage";
import LoginPage from "./pages/LoginPage";
import NewsroomDashboard from "./pages/AdminDashboard";
import DynamicPage from "./pages/DynamicPage";
import { Live } from "./pages/StaticPages";
import { AuthProvider } from "./lib/auth";

function App() {
  const [lang, setLang] = useState("hi");
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Header lang={lang} setLang={setLang} />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/article/:slug" element={<ArticlePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin" element={<NewsroomDashboard />} />
              <Route path="/newsroom" element={<NewsroomDashboard />} />
              <Route path="/p/:slug" element={<DynamicPage />} />
              <Route path="/live" element={<Live />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
